import { UserManager } from "oidc-client";
import { AUTH_PROVIDER_PROPS } from "./constants";
import axios from "axios";
export const userManager = new UserManager(AUTH_PROVIDER_PROPS);

export const login = async () => {
  await userManager.signinRedirect();
};

const URL_PARAMS_WITH_CODE = [
  "access_token",
  "code",
  "id_token",
  "session_state",
];

export const hasCodeInUrl = (location) => {
  const searchParams = new URLSearchParams(location.search);
  const hashParams = new URLSearchParams(location.hash.replace("#", "?"));

  return URL_PARAMS_WITH_CODE.some((param) =>
    Boolean(searchParams.get(param) || hashParams.get(param))
  );
};

export const loadUserInfo = async (user) => {
  try {
    const userInfoUrl = await userManager.metadataService.getUserInfoEndpoint();
    const userInfo = await axios.get(userInfoUrl, {
      headers: {
        Authorization: `Bearer ${user.access_token}`,
      },
    });
    return {
      ...user,
      profile: userInfo.data ?? {},
    };
  } catch (e) {
    console.warn(e);
    return null;
  }
};

export const userLogout = async (endpoint) => {
  await userManager.removeUser();
  await userManager.signoutRedirect().then((data) => {
    window.location.replace(endpoint);
  });
};

export const getUser = async () => {
  return await userManager.getUser();
};

export const handleCallback = async () => {
  let user = await userManager.signinCallback();
  return user;
};

export const isAuthenticated = async () => {
  const user = await getUser();
  return user !== null;
};
